import { NavLink, Outlet, useNavigate } from 'react-router-dom'

import { displayName, useAuth } from '@/shared/auth/useAuth'
import { Corners } from '@/shared/ui/Blueprint'
import { Wordmark } from '@/shared/ui/Wordmark'

const navLink = { fontSize: 15, letterSpacing: '0.01em' }

export function AppLayout() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <header
        className="nav"
        style={{
          padding: '12px clamp(14px,4vw,28px)',
          gap: 'clamp(12px,2vw,26px)',
          flexWrap: 'wrap',
          borderBottom: '1px solid var(--color-divider)',
          position: 'sticky',
          top: 0,
          background: 'var(--color-bg)',
          zIndex: 5,
        }}
      >
        <div className="nav-brand" style={{ marginRight: 0, display: 'flex', alignItems: 'baseline', gap: 8 }}>
          <Wordmark />
          <span className="kicker" style={{ fontFamily: 'var(--font-body)', letterSpacing: '0.12em' }}>
            console de controle
          </span>
        </div>
        <nav style={{ display: 'flex', gap: 'clamp(14px,2.5vw,22px)', alignItems: 'center', flexWrap: 'wrap' }}>
          <NavLink to="/dispositivos" className="heading" style={navLink}>
            Dispositivos
          </NavLink>
          <NavLink to="/mcp" className="heading" style={navLink}>
            Conexão MCP
          </NavLink>
        </nav>
        <div style={{ flex: '1 1 0', minWidth: 0 }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <button
            type="button"
            className="btn btn-primary blueprint"
            onClick={() => navigate('/dispositivos/adicionar')}
            style={{ padding: '9px 14px', minHeight: 42 }}
          >
            <Corners />
            Adicionar dispositivo
          </button>
          <span style={{ width: 1, height: 26, background: 'var(--color-divider)' }} />
          <span style={{ fontSize: 14 }}>{displayName(user)}</span>
          <button type="button" className="btn btn-ghost" onClick={logout} style={{ minHeight: 42 }}>
            Sair
          </button>
        </div>
      </header>
      <main
        style={{
          flex: 1,
          width: '100%',
          maxWidth: 1400,
          margin: '0 auto',
          padding: 'clamp(18px,4vw,26px) clamp(14px,4vw,28px) 60px',
        }}
      >
        <Outlet />
      </main>
    </div>
  )
}
